export const MEDALLAS_LOADING = 'MEDALLAS_LOADING';
export const MEDALLAS_LOADED = 'MEDALLAS_LOADED';
export const MEDALLAS_ERROR = 'MEDALLAS_ERROR';

export const MEDALLAS_INDI_LOADING = 'MEDALLAS_INDI_LOADING';
export const MEDALLAS_INDI_LOADED = 'MEDALLAS_INDI_LOADED';
export const MEDALLAS_INDI_ERROR = 'MEDALLAS_INDI_ERROR';

export const MEDALLAS_CONTEXTO_DEX_LOADING = 'MEDALLAS_CONTEXTO_DEX_LOADING';
export const MEDALLAS_CONTEXTO_DEX_LOADED = 'MEDALLAS_CONTEXTO_DEX_LOADED';
export const MEDALLAS_CONTEXTO_DEX_ERROR = 'MEDALLAS_CONTEXTO_DEX_ERROR';

export const MEDALLAS_DEX_LOADING = 'MEDALLAS_DEX_LOADING';
export const MEDALLAS_DEX_LOADED = 'MEDALLAS_DEX_LOADED';
export const MEDALLAS_DEX_ERROR = 'MEDALLAS_DEX_ERROR';    

export const CREAR_MEDALLA_DEX_LOADING = 'CREAR_MEDALLA_DEX_LOADING';
export const CREAR_MEDALLA_DEX_LOADED = 'CREAR_MEDALLA_DEX_LOADED';
export const CREAR_MEDALLA_DEX_ERROR = 'CREAR_MEDALLA_DEX_ERROR';    
export const RESET_CREAR_MEDALLA_DEX = "RESET_CREAR_MEDALLA_DEX";

export const MEDALLAS_USER_DEX_LOADING = 'MEDALLAS_USER_DEX_LOADING';
export const MEDALLAS_USER_DEX_LOADED = 'MEDALLAS_USER_DEX_LOADED';
export const MEDALLAS_USER_DEX_ERROR = 'MEDALLAS_USER_DEX_ERROR';    